<template>
<div>
    <div>
        <vs-button @click="id=0;popupAddPrueba = true;" color="success" type="gradient">Agregar Prueba</vs-button>
        <vs-table max-items="10" search pagination :data="arrayPrueba">
            <template slot="header">
                <vs-chip color="primary">Cantidad: <b> {{ arrayPrueba.length }}</b></vs-chip>
            </template>
            <template slot="thead">
                <vs-th>Nombre</vs-th>
                <vs-th>archivo</vs-th>
                <vs-th style="width:100px;">Acciones</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        {{data[indextr].nombre}}<br>
                    </vs-td>
                    <vs-td>
                        {{ tr.archivo }}
                    </vs-td>
                    <vs-td>
                        <vx-tooltip style="display: inline-block;" text="Editar nivel" position="top" color="primary">
                            <vs-button class="modal-default-button" color="success" @click="ObjectSelected=tr;openModalEditar(data[indextr])" type="filled" icon-pack="feather" icon="icon-edit"> </vs-button>
                        </vx-tooltip> &nbsp;
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <!--modal-->
        <vs-popup classContent="popup-example" fullscreen title="Agregar Prueba" :active.sync="popupAddPrueba">
            <div v-if="popupAddPrueba">
                <vs-input class="inputx mb-3 w-full" label="Nombre" v-model="prueba.nombre" />
                <div class="vx-row">
                    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-6">
                        <AddVue v-model="archivo1" modelName="archivo1" :ObjectPadre="ObjectSelected" :id="id" :carpeta="carpeta" />
                    </div>
                </div>
                <div class="flex justify-center">
                    <vs-button color="success" class="mb-3" @click="guardarPrueba()" type="gradient">Guardar</vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</div>
</template>

<script>
import AddVue from './add.vue'
export default {
    components: {
        AddVue,
    },
    data() {
        return {
            arrayPrueba: [],
            popupAddPrueba: false,
            prueba: {
                nombre: '',
            },
            archivo1: null,
            archivo2: null,
            id: 0,
            ObjectSelected: '',
            carpeta: 'pruebas',
            imgOld: '',
        };
    },
    mounted() {
        this.getPrueba();
    },
    methods: {
        getPrueba() {
            let me = this;
            this.$http.get(this.$server_url + 'prueba')
                .then(function (res) {
                    me.$vs.loading.close()
                    me.arrayPrueba = res.data
                })
                .catch(function (error) {
                    console.log(error + ' error');
                    me.$vs.loading.close()
                })
        },
        openModalEditar(data) {
            let me = this;
            me.id = data.id;
            me.prueba.nombre = data.nombre;
            me.imgOld = data.url;
            me.popupAddPrueba = true;
        },
        guardarPrueba() {
            let me = this;
            let formData = new FormData();
            formData.append('id', me.id)
            formData.append('nombre', me.prueba.nombre)
            this.$http.post(this.$server_url + 'prueba', formData)
                .then(function (res) {
                    me.getPrueba();
                    // me.popupAddPrueba = false;
                    let getId = res.data.id;
                    me.guardarFiles(getId);
                })
        },
        guardarFiles(getId) {
            let me = this;
            let formData = new FormData();
            formData.append('id', getId)
            formData.append('archivo1', me.archivo1)
            formData.append('archivo2', me.archivo2)
            formData.append('imgOld', me.imgOld)
            formData.append('ruta', "pruebas")
            //save en tabla
            //nombre modelo
            formData.append('nombreM', "Prueba")
            formData.append('guardarTabla', "1")
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            this.$http.post(this.$data_url + 'api/guardarDocumentos', formData, config)
                .then(() => {
                    me.popupAddPrueba = false;
                    me.$vs.notify({
                        title: 'Guardado',
                        text: 'Se ha guardado correctamente',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check',
                    });
                    // me.guardarPrueba2(result.data.archivos);
                }).catch(() => {});
        },
    }
};
</script>

<style>
/* Add your custom styles here */
</style>
